export default __webpack_public_path__ + "static/media/voice-toggle-1.239b22ad.webp";